import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
// material

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Moment from 'moment';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { format } from "date-fns";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AccordionDetails, Select, TextareaAutosize, Autocomplete, Stack, Grid, Divider, TextField, FormControl, FormGroup, InputLabel, FormControlLabel, Checkbox, Modal, IconButton, Typography, Tooltip, MenuItem, Button, Box, Menu, Tabs, Tab, FormHelperText, FormLabel, Card, ListItemText, ListItemIcon, Chip, Dialog, DialogContent, } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ListIcon from '@mui/icons-material/List';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
// import IssueAllocationServicePage from '../../SidebarMenuComponents/ServiceComponent/IssueAllocationServicePage'
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';
import ApplyForLeave from '../LeaveComponent/ApplyForLeave';

// -----------------------------------------------------------------------------------------------------
const viewStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fbe9e7', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));
const TextAccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#FFF', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function LeaveHistory({ fromDate, handleFromDate, toDate, handleToDate, leaveType, handleLeaveType, leaveHistoryData, handleFilterLeaveHistory, handleLeaveHistoryReset, viewLeaveHistoryModal, handleViewLeaveHistoryCloseModal, historyColumns, viewLeaveHistoryData, cancelModal, handleCancelConfirm, handleCancelClick, editModalOpen, setEditModalOpen, setEditModalData, editModalData, pastLeaveColumns, upcomingLeaveColumns, leaveTypeRadio, handleLeaveTypeRadio, formattedDate, formattedDay, handleDeleteDate, teamImpactColumns, handleEditDate, handleEditRemark, handleUpdateLeave, handleEditOpenModal, handleEditCloseModal, leaveTypeOptions, handleExecutiveDdl, executiveDdl, selectedExecutiveDdl, leavePaid, setLeavePaid, leavePaidOptions, handleLongLeaveFromDate, fromDateLeave, handleLongLeaveToDate, toDateLeave, pageSize2, setPageSize2, openSuccess, setOpenSuccess, handleSuccessClose, pastLeaveData, upcomingLeaveData, teamImpactLeaveData, projectImpactLeaveData, isEditMode, selectedExecutiveHistory, executiveHistory, handleExecutiveHistory, isManager }) {

    return (
        <Box sx={{ p: 2 }}>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                        inputFormat="dd/MMM/yyyy"
                        value={fromDate ? Moment(fromDate, 'DD-MMM-YYYY').toDate() : null}
                        onChange={handleFromDate}
                        renderInput={(params) => <TextField size="small" {...params} sx={{ width: 180 }} error={false} inputProps={{
                            ...params.inputProps,
                            placeholder: fromDate ? params.inputProps?.placeholder : "From Date"
                        }} />}
                    />
                    <DesktopDatePicker
                        inputFormat="dd/MMM/yyyy"
                        value={toDate ? Moment(toDate, 'DD-MMM-YYYY').toDate() : null}
                        onChange={handleToDate}
                        renderInput={(params) => <TextField size="small" {...params} sx={{ width: 180 }} error={false} inputProps={{
                            ...params.inputProps,
                            placeholder: toDate ? params.inputProps?.placeholder : "To Date"
                        }} />}
                    />
                </LocalizationProvider>
                <FormControl size="small" fullWidth sx={{ width: 180 }}>
                    <Autocomplete
                        fullWidth
                        size="small"
                        id="leaveType"
                        value={leaveTypeOptions.find(option => option.Id === leaveType) || ""}
                        onChange={(_, newValue) => handleLeaveType(newValue)}
                        options={leaveTypeOptions}
                        getOptionLabel={(option) => option?.Name || ""}
                        renderInput={(params) => <TextField {...params} placeholder="Select Leave Type" />}
                        renderOption={(props, option) => (
                            <li {...props} key={option.Id}>
                                {option.Name}
                            </li>
                        )}
                    />

                </FormControl>
                {isManager && (
                    <FormControl size="small" fullWidth sx={{ flex: 1 }}>
                        <Autocomplete
                            fullWidth
                            size="small"
                            id="executive"
                            value={selectedExecutiveHistory.find((option) => option.Id === executiveHistory) || ""}
                            onChange={(_, newValue) => handleExecutiveHistory(newValue)}
                            options={selectedExecutiveHistory}
                            getOptionLabel={(option) => option.Name || ""}
                            isOptionEqualToValue={(option, value) => option.Id === value.Id}

                            renderInput={(params) => (
                                <TextField {...params} placeholder="Select Executive" />
                            )}
                            renderOption={(props, option) => (
                                <li {...props} key={option.Id}>
                                    {option.Name}
                                </li>
                            )}
                        />


                    </FormControl>
                )}

                <Tooltip title="Filter">
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleFilterLeaveHistory}
                        sx={{ minWidth: 40, }}

                    >
                        <Icon icon="material-symbols:search" width="20" height="20" sx={{ mr: '3px' }} />
                    </Button>
                </Tooltip>

                {/* Reset */}
                <Tooltip title="Reset">
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleLeaveHistoryReset}
                        sx={{ minWidth: 40, }}

                    >
                        <Icon icon="ic:twotone-restart-alt" width="20" height="20" />
                    </Button>
                </Tooltip>
            </Stack>
            <Modal open={viewLeaveHistoryModal} onClose={handleViewLeaveHistoryCloseModal}>
                <Box sx={viewStyle}>
                    {/* Header */}
                    <Box
                        sx={{
                            borderBottom: '1px solid #D1D5DB',
                            px: 2,
                            py: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Typography variant="h6" fontWeight={600}>
                            Leave Request
                        </Typography>
                        <IconButton size="small" onClick={handleViewLeaveHistoryCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Body */}
                    <Box sx={{ p: 2 }}>
                        {viewLeaveHistoryData && (
                            <Stack spacing={1.5}>

                                {/* Status */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Status</Typography>
                                    <Chip
                                        label={viewLeaveHistoryData.Status}
                                        size="small"
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: 12,
                                            color:
                                                viewLeaveHistoryData.Status === 'Approved'
                                                    ? '#00A63E'
                                                    : viewLeaveHistoryData.Status === 'Pending'
                                                        ? '#894B00'
                                                        : viewLeaveHistoryData.Status === 'Rejected'
                                                            ? '#D93A46'
                                                            : '',

                                            bgcolor:
                                                viewLeaveHistoryData.Status === 'Approved'
                                                    ? '#E5F5EB'
                                                    : viewLeaveHistoryData.Status === 'Pending'
                                                        ? '#FEF9C2'
                                                        : viewLeaveHistoryData.Status === 'Rejected'
                                                            ? '#FAE3E6'
                                                            : ''
                                        }}
                                    />
                                </Box>

                                {/* Applied Date */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Applied Date</Typography>
                                    <Typography fontWeight={500}>
                                        {viewLeaveHistoryData.EntryDate
                                            ? Moment(viewLeaveHistoryData.EntryDate).format("DD-MMM-YYYY")
                                            : ""}
                                    </Typography>
                                </Box>

                                {/* Leave Type */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Leave Dates</Typography>
                                    <Typography fontWeight={500}>
                                        {viewLeaveHistoryData.LeaveType}
                                    </Typography>
                                </Box>

                              

                                {/* Remark */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary"> Remark</Typography>
                                    <Typography fontWeight={500}>
                                        {viewLeaveHistoryData.LeaveRemarks}
                                    </Typography>
                                </Box>

                            </Stack>
                        )}
                    </Box>
                </Box>
            </Modal>
            {cancelModal && (
                <Modal open={cancelModal} onClose={handleCancelClick}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 380,
                            bgcolor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "none",
                            p: 2,
                        }}
                    >
                        {/* MESSAGE */}
                        <Typography fontSize="14px" fontWeight="600">
                            Are you sure you want to cancel the leave request ?
                        </Typography>

                        {/* ACTIONS */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: 2,
                                mt: 3,
                            }}
                        >
                            {/* NO */}
                            <Typography
                                onClick={handleCancelClick}
                                sx={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    fontWeight: 600,
                                    color: "#000",
                                    fontSize: '14px'
                                }}
                            >
                                No
                            </Typography>

                            {/* YES */}
                            <Button
                                variant="contained"
                                onClick={handleCancelConfirm}
                                sx={{
                                    backgroundColor: "#FF2B2B",
                                    borderRadius: "8px",
                                    px: 3,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": {
                                        backgroundColor: "#FF2B2B",
                                    },
                                    fontSize: '14px'

                                }}
                            >
                                Yes
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            )}
            <Modal
                open={editModalOpen}
                onClose={handleEditCloseModal}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: '80%',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        // maxHeight: '80vh',
                        overflow: 'auto',
                        borderRadius: '8px',
                    }}
                >

                    {/* Modal Header */}

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '0px 16px',
                            borderBottom: '1px solid #E0E0E0',
                            backgroundColor: '#fff',
                            m: 0, // remove outer margins
                        }}
                    >
                        <Typography variant="h6" fontWeight='bold'>
                            Apply for Leave
                        </Typography>

                        <IconButton
                            onClick={handleEditCloseModal}
                            sx={{
                                color: 'grey',
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    {/* Apply Form */}
                    <ApplyForLeave
                        date={editModalData?.dates || []}
                        handleDate={handleEditDate}
                        remark={editModalData?.remark || ""}
                        handleRemark={handleEditRemark}
                        pastLeaveColumns={pastLeaveColumns}
                        upcomingLeaveColumns={upcomingLeaveColumns}
                        handleApplyForLeave={handleUpdateLeave}
                        leaveTypeRadio={leaveTypeRadio}
                        handleLeaveTypeRadio={handleLeaveTypeRadio}
                        teamImpactColumns={teamImpactColumns}
                        handleExecutiveDdl={handleExecutiveDdl}
                        executiveDdl={executiveDdl}
                        selectedExecutiveDdl={selectedExecutiveDdl}
                        leavePaid={leavePaid}
                        setLeavePaid={setLeavePaid}
                        leavePaidOptions={leavePaidOptions}
                        handleLongLeaveFromDate={handleLongLeaveFromDate}
                        fromDateLeave={fromDateLeave}
                        handleLongLeaveToDate={handleLongLeaveToDate}
                        toDateLeave={toDateLeave}
                        leaveTypeOptions={leaveTypeOptions}
                        pastLeaveData={pastLeaveData}
                        upcomingLeaveData={upcomingLeaveData}
                        teamImpactLeaveData={teamImpactLeaveData}
                        projectImpactLeaveData={projectImpactLeaveData}
                        isEditMode={isEditMode}
                    />
                </Box>
            </Modal>
            <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)}>
                <DialogContent sx={{ textAlign: "center", p: 2, width: "288px", overflow: 'hidden' }}>
                    {/* Green check circle */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#4caf50",
                            borderRadius: "50%",
                            width: 40,
                            height: 40,
                            mx: "auto",

                        }}
                    >
                        <Icon icon="mdi:check" color="white" width={28} height={28} />
                    </Box>

                    {/* Title */}
                    <Typography variant="h5" gutterBottom sx={{ fontSize: '24px', color: '#000000' }}>
                        Applied!
                    </Typography>

                    {/* Message */}
                    <Typography variant="body2" sx={{ mb: 2, color: '#888787', fontSize: '14px' }}>
                        Your leave has been updated successfully.
                    </Typography>
                    <Button
                        variant="contained"
                        sx={{ width: 200 }}
                        onClick={handleSuccessClose}
                    >
                        Done
                    </Button>
                </DialogContent>
            </Dialog>

            {/* DataGrid for History */}
            <Box sx={{ height: '60vh', width: '100%', }}>

                <DataGrid
                    rows={leaveHistoryData}
                    columns={historyColumns}
                    density="compact"
                    getRowId={(row) => row.id || leaveHistoryData.indexOf(row)}
                    getRowHeight={() => 'auto'}
                    components={{ Toolbar: GridToolbar, }}
                    pagination
                    paginationMode="client"
                    rowsPerPageOptions={[25, 50, 100]}
                    pageSize={pageSize2}
                    onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                />
            </Box>
        </Box>
    );
}